export function toLocalYmd(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  // Already a pure YYYY-MM-DD string
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  // Accept common DD-MM-YYYY / DD/MM/YYYY inputs
  const dmy = raw.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
  if (dmy) {
    return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
  }

  const d =
    value instanceof Date
      ? value
      : new Date(/^\d{4}-\d{2}-\d{2}/.test(raw) ? raw.replace(" ", "T") : raw);
  if (Number.isNaN(d.getTime())) {
    const pre = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    return pre ? pre[1] : "";
  }

  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayLocalYmd() {
  return toLocalYmd(new Date());
}

